import styled from 'styled-components'
import { MessageErrorUnstyled } from './unstyled'

export const MessageError = styled(MessageErrorUnstyled)`
  color: ${props => props.theme.colors.primary};
  margin-top: 30px;
`



// WEBPACK FOOTER //
// ./src/Components/Message/Error/index.js